// WP-21 — the ONE Organization node for structured data. Values mirror the published legal
// pages (core/legal_defaults.py): legal name, CIN and registered office are real company
// records — never invent ratings, reviews, awards or social profiles here. sameAs appears
// ONLY when the CMS carries real published profiles (organizationSchemaFor below) — the base
// node deliberately has none.
import { SALES_EMAIL, SALES_PHONE } from "../../lib/contactInfo";
import { validSocialLinks } from "./socialIcons";

export const ORGANIZATION_ID = "https://vidyapeeth360.com/#organization";

export const ORGANIZATION_SCHEMA = Object.freeze({
  "@type": "Organization",
  "@id": ORGANIZATION_ID,
  name: "Vidyapeeth360",
  legalName: "HelpRevX Software Private Limited",
  identifier: { "@type": "PropertyValue", propertyID: "CIN", value: "U620110D2026PTC053140" },
  url: "https://vidyapeeth360.com/",
  logo: "https://vidyapeeth360.com/vidyapeethNewlogo.png",
  email: SALES_EMAIL,
  address: {
    "@type": "PostalAddress",
    streetAddress: "No. 7, R K Nagar, Padmapur",
    addressLocality: "Rayagada",
    addressRegion: "Odisha",
    postalCode: "765026",
    addressCountry: "IN",
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: SALES_PHONE.tel.replace("+91", "+91-"),
    contactType: "sales",
    areaServed: "IN",
  },
});

// The Organization node with the CMS-published social profiles as sameAs (TRUST-15 — real
// profiles only, published via /platform?view=landing-cms). With no valid links this returns
// the frozen base node ITSELF, so an empty/absent CMS section publishes byte-identical
// structured data (never an empty sameAs array, never invented profiles).
export function organizationSchemaFor(socialLinks) {
  const links = validSocialLinks(socialLinks);
  if (!links.length) return ORGANIZATION_SCHEMA;
  return { ...ORGANIZATION_SCHEMA, sameAs: links.map((link) => link.url) };
}

